import { Reducer } from 'redux';
import { HotTableStoreActions, HotTableStoreState } from '../hotTableStoreTypes';

const activeTableReducer: Reducer<HotTableStoreState['activeTable'], HotTableStoreActions> = (state = null, action) => {
    switch (action.type) {
        case 'SET_ACTIVE_TABLE':
            return action.activeTable;
        default:
            return state;
    }
};

export default activeTableReducer;
